import { RefObject, useEffect, useState } from 'react';
import { BoxContextValue } from '../FeatureAppTypes';
import { getBoundingClient } from './get-bounding-client';

export const useClientRect = <T extends HTMLElement>(ref: RefObject<T>) => {
  const [viewBox, setBox] = useState<BoxContextValue>({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (ref.current) setBox(getBoundingClient(ref));
  }, []);

  useEffect(() => {
    const handleEvent = () => {
      if (ref.current) setBox(getBoundingClient(ref));
    };

    window.addEventListener('resize', handleEvent);
    window.addEventListener('orientationchange', handleEvent);

    return () => {
      window.removeEventListener('resize', handleEvent);
      window.removeEventListener('orientationchange', handleEvent);
    };
  }, []);

  return viewBox;
};
